<template>
  <footer class="footer" data-scroll-section >
    <div class="footer-container">
      <!-- 로고 영역 -->
      <div class="footer-logo">
        <img :src="require('@/assets/footer_logo.svg')" alt="AirSignal Logo" height="40" />
      </div>

      <!-- 회색 선 -->
      <hr class="footer-divider" />

      <!-- 텍스트 영역 -->
      <div class="footer-content">
        <div class="footer-row">
          <p>본사 : 경기도 성남시 중원구 성남대로 993, 602호 (오렌지카운티, 여수동)</p>
        </div>
        <div class="footer-row">
          <p>연구소 : 경기도 성남시 수정구 창업로 54, 504호(기업성장센터, 시흥동)</p>
        </div>
        <div class="footer-row">
          <p>T. 031-756-1251</p>
        </div>
        <span class="footer-line-block" style="">|</span>
        <div class="footer-row">
          
          <p>F. 031-756-1252</p>
        </div>
        <span class="footer-line-block">|</span>
        <div class="footer-row">

          <p>hjkim@airsignal.kr</p>
        </div>
        <div class="copyright">
          <p>
            Copyright © AirSignal Corporation. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
.footer {
  border-top: 1px solid #E6E6E6;
  background-color: #fff; /* 푸터 배경색 */
  padding: 60px 0 ;
  display: flex;
  justify-content: center;
  font-family: 'Pretendard',sans-serif;
}

.footer-container {
  width: 100%;
  max-width: 1592px;
  display: flex;
  flex-direction: column;
  color: #8d8d8d;
  font-size: 14px;
  line-height: 1.4;
}

.footer-logo img {
  width: 140px; /* 로고 너비 설정 */
}

.footer-divider {
  width: 100%;
  height: 1px;
  background-color: #f1f1f1 ; /* 회색 선 */
  border: none;
  margin-top: 12px;
  margin-bottom: 20px ;
}


.footer-row {
  display: inline-block;
  margin-bottom: 4px;
}

.footer-row:nth-child(2){
  display: block;
}

.footer-line-block {
  display: inline-block;
  margin: 0 10px;
  color: #D3D3D3;
}


.footer-content p {
  margin: 0;
  padding: 0;
}

.copyright {
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #999;
}


.footer-inline p:not(:last-child)::after {
  content: "|";
  margin-left: 10px;
  color: #8d8d8d;
}

@media (max-width: 1592px) {
  .footer-container {
    padding: 0 40px;
  }
}

@media (max-width: 768px) {
  


  .footer-logo img {
    width: 140px;
  }

  .footer-divider {
    display: none;
  }

  .footer-container {
    
    padding: 20px 20px;
  }
  .footer {
    padding: 12px 0;
  }

  .footer-content {
    font-size: 12px;
  }
  .footer-line-block {
    margin: 0 8px;
  }

  

  .copyright {
    font-size: 12px;
  }
}
</style>
